import React from 'react';
import { element, number, string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { Hydrator } from '@thd-olt-component-react/hydrator';
import { RecentlyViewed as RecentlyViewedComponent } from '@thd-olt-component-react/thd-recs-containers';
import { Card, CardTitle } from '@thd-olt-component-react/core-ui';

import classnames from 'classnames/bind';
import componentStyles from '../components.module.scss';

const styles = classnames.bind(componentStyles);

export function CustomRenderedRecentlyViewed({
  SCROLL_BUFFER,
  HOMEPAGE_DELAY_STANDARD,
  PLACEHOLDER,

  id,
  brandTitleMaxLine,
  slidesPer,
}) {
  return (
    <div key={id} className={styles('component__container--light')}>
      <Hydrator
        id="recentlyViewed-php-hydrator"
        className={styles('u-height-100')}
        scrollBuffer={SCROLL_BUFFER}
        delay={HOMEPAGE_DELAY_STANDARD}
        placeholder={PLACEHOLDER}
      >
        <QueryProvider cacheKey="rv_homepage_rr" persist>
          <Card>
            {/**
             * @TODO
             *
             * Refactor so that we're using CSS modules for
             * `app.scss` styles.
             * */}
            <CardTitle
              className="card__title u-width-100"
              title="Recently Viewed"
            />
            <RecentlyViewedComponent
              brandTitleMaxLine={brandTitleMaxLine}
              slidesPer={slidesPer}
              hideTitle
              schemaName="rv_homepage_rr"
              showFallback
              entryId={id}
            />
          </Card>
        </QueryProvider>
      </Hydrator>
    </div>
  );
}
CustomRenderedRecentlyViewed.propTypes = {
  SCROLL_BUFFER: number,
  HOMEPAGE_DELAY_STANDARD: number,
  PLACEHOLDER: element,

  brandTitleMaxLine: number,
  slidesPer: number,
  id: string,
};

CustomRenderedRecentlyViewed.defaultProps = {
  SCROLL_BUFFER: undefined,
  HOMEPAGE_DELAY_STANDARD: undefined,
  PLACEHOLDER: undefined,

  brandTitleMaxLine: undefined,
  slidesPer: undefined,
  id: undefined,
};
